import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const promptText = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    display: none;
  }
`;
